import type { EntitlementStatus } from './types';
import { OFFLINE_CACHE_DAYS } from './types';

const STORAGE_KEY = 'pouches_entitlement_v1';
const LEGACY_FLAG_KEY = 'pouches_billing_legacy_applied_v1';
const BILLING_INTRO_KEY = 'pouches_billing_intro_v1';

export interface StoredEntitlement extends EntitlementStatus {
  cachedUntil: string;
}

function addDaysIso(days: number): string {
  const date = new Date();
  date.setDate(date.getDate() + days);
  return date.toISOString();
}

export function readCachedEntitlement(now = Date.now()): EntitlementStatus | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as StoredEntitlement;
    if (!parsed?.tier || !parsed.cachedUntil) return null;
    if (Date.parse(parsed.cachedUntil) < now) return null;
    if (parsed.source === 'legacy' && parsed.tier === 'pro') {
      return { tier: 'free', source: 'legacy', cachedUntil: parsed.cachedUntil };
    }
    return parsed;
  } catch {
    return null;
  }
}

export function writeCachedEntitlement(status: EntitlementStatus, now = Date.now()): StoredEntitlement {
  const cachedUntil =
    status.cachedUntil && Date.parse(status.cachedUntil) > now
      ? status.cachedUntil
      : addDaysIso(OFFLINE_CACHE_DAYS);
  const stored: StoredEntitlement = { ...status, cachedUntil };
  localStorage.setItem(STORAGE_KEY, JSON.stringify(stored));
  return stored;
}

export function clearCachedEntitlement(): void {
  localStorage.removeItem(STORAGE_KEY);
}

export function isLegacyAlreadyApplied(): boolean {
  return localStorage.getItem(LEGACY_FLAG_KEY) === '1';
}

export function markLegacyApplied(): void {
  localStorage.setItem(LEGACY_FLAG_KEY, '1');
}

export function isBillingIntroApplied(): boolean {
  return localStorage.getItem(BILLING_INTRO_KEY) === '1';
}

export function markBillingIntroApplied(): void {
  localStorage.setItem(BILLING_INTRO_KEY, '1');
}
